/* eslint-disable no-restricted-globals */
import React, { Component, createRef } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  withStyles,
  Typography,
  withMobileDialog,
  Dialog,
  DialogActions,
  IconButton,
  Hidden,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { deleteEntity } from 'actions/data'
import { listContactsInStage } from 'actions/campaign'
import { clickContactCount } from 'actions/campaign/addOrEdit'
import language from 'utils/vast-languagepack'
import Panels from 'components/ContactsPage/Panels'
import Button from 'components/theme/Button'
import { selectAllContacts } from 'actions/contacts/groups'
import { deselectAllContacts } from 'actions/contacts/addOrEdit'

const mapStateToProps = state => ({
  campaignID: state.campaign.addOrEdit.campaign.id,
  contactIDsInStagesByCampaignID: state.campaign.contactIDsInStagesByCampaignID,
  contacts: state.contacts.contactsWithEmailsByID,
  stageSelectedForContactView:
    state.campaign.addOrEdit.stageSelectedForContactView.id,
  stageName: state.campaign.addOrEdit.stageSelectedForContactView.name,
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      deleteEntity,
      listContactsInStage,
      clickContactCount,
      selectAllContacts,
      deselectAllContacts,
    },
    dispatch,
  )
}

const styles = theme => ({
  rounded: {
    borderRadius: 28,
    overflowY: 'hidden',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      overflowY: 'auto',
    },
  },
})

const ContactsList = connect(
  state => ({
    loading: state.cursor.contactsInStage?.loading,
    cursor: state.cursor.contactsInStage?.cursor,
  }),
  null,
)(({ contacts, loading, cursor, listFn, campaignID, deleteThenFn }) => {
  return (
    <Panels
      paginated
      listFn={listFn}
      contacts={contacts}
      loading={loading}
      cursor={cursor}
      campaignID={campaignID}
      deleteThenFn={deleteThenFn}
    />
  )
})

class ContactsInStageModal extends Component {
  constructor(props) {
    super(props)
    this.state = { contacts: [] }
    this.ref = createRef()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.stageSelectedForContactView !==
      prevProps.stageSelectedForContactView
    ) {
      if (this.props.stageSelectedForContactView) {
        this.props
          .listContactsInStage(
            this.props.campaignID,
            this.props.stageSelectedForContactView,
          )
          .then(payload =>
            this.setState({
              contacts: payload.contacts ? payload.contacts : [],
            }),
          )
      } else {
        this.setState({ contacts: [] })
      }
    }
  }

  selectAllClick = () => {
    if (this.state.selectAllClicked) {
      this.setState({ selectAllClicked: false })
      this.props.deselectAllContacts()
    } else {
      this.setState({ selectAllClicked: true })
      this.props.selectAllContacts()
    }
  }

  close = () => {
    this.props.deselectAllContacts()
    this.props.clickContactCount()
  }

  render() {
    const {
      fullScreen,
      classes,
      stageSelectedForContactView,
      clickContactCount,
      stageName,
    } = this.props

    const selectAllButton = (
      <Button onClick={this.selectAllClick}>
        {this.state.selectAllClicked ? 'Deselect all' : 'Select all'}
      </Button>
    )

    return stageSelectedForContactView ? (
      <Dialog
        fullWidth
        maxWidth="xl"
        fullScreen={fullScreen}
        open={Boolean(stageSelectedForContactView)}
        onClose={() => clickContactCount()}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{ classes: { rounded: classes.rounded } }}
        ref={this.ref}
      >
        <div
          style={{
            padding: 20,
            fontSize: 20,
            borderBottom: '1px solid #c5c5c5',
            position: 'relative',
          }}
        >
          {`Contacts currently in stage '${stageName}'`}
          <Hidden smDown>
            <>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: 75,
                  transform: 'translate(0, -50%)',
                }}
              >
                {selectAllButton}
              </div>
            </>
          </Hidden>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              right: 20,
              transform: 'translate(0, -50%)',
            }}
          >
            <IconButton onClick={this.close}>
              <Close />
            </IconButton>
          </div>
        </div>
        <div>
          {this.state.contacts.length ? (
            <ContactsList
              listFn={() =>
                this.props
                  .listContactsInStage(
                    this.props.campaignID,
                    this.props.stageSelectedForContactView,
                  )
                  .then(payload =>
                    this.setState({
                      contacts: [
                        ...this.state.contacts,
                        ...(payload.contacts || []),
                      ],
                    }),
                  )
              }
              contacts={this.state.contacts}
              campaignID={this.props.campaignID}
              deleteThenFn={index =>
                this.setState({
                  contacts: this.state.contacts
                    .slice(0, index)
                    .concat(this.state.contacts.slice(index + 1)),
                })
              }
            />
          ) : (
            <Typography variant="h2" gutterBottom>
              {language.campaign.helperText.noResults}
            </Typography>
          )}
        </div>
        <DialogActions>
          <Hidden mdUp>{selectAllButton}</Hidden>
          <Button onClick={this.close}>Close</Button>
        </DialogActions>
      </Dialog>
    ) : null
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles)(withMobileDialog()(ContactsInStageModal))),
)
